import { render } from "./FloatingButtons.vue?vue&type=template&id=7fc44360"
import script from "./FloatingButtons.vue?vue&type=script&lang=js"
export * from "./FloatingButtons.vue?vue&type=script&lang=js"

import "./FloatingButtons.vue?vue&type=style&index=0&id=7fc44360&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__